"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validMfaSetupValues = exports.validAuthLevels = exports.allowedMfaSetupValues = void 0;
const validAuthLevels = [
    'krn:portal-auth:loa:0fa',
    'krn:portal-auth:loa:1fa',
    'krn:portal-auth:loa:2fa'
];
exports.validAuthLevels = validAuthLevels;
const validMfaSetupValues = ['EMAIL', 'NONE', 'SMS', 'TOTP'];
exports.validMfaSetupValues = validMfaSetupValues;
const allowedMfaSetupValues = validMfaSetupValues.filter(value => value !== 'NONE');
exports.allowedMfaSetupValues = allowedMfaSetupValues;
